import HelpIcon from '../HelpIcon'
import { CIMSSectionProps } from './types'
import CIMSDivider from '../CIMSDivider'
import { Spin } from 'antd'

/**
 * prefixes {@link children} with a {@link CIMSDivider}, wrapped in a {@link Spin}
 * component
 *
 * the divider holds the {@link title} and {@link help} message
 */
const CIMSSection: React.FC<CIMSSectionProps> = ({
  help,
  title,
  children,
  loading,
}) => {
  return (
    <Spin spinning={loading ?? false}>
      <CIMSDivider>{<HelpIcon text={help}>{title}</HelpIcon>}</CIMSDivider>
      {children}
    </Spin>
  )
}

export default CIMSSection
